import React, { useState, useEffect } from 'react';
import { Tabs, TabHeader, TabPanel } from '@wk/components-react16';
import RoleManagement from './RoleManagement';
import UserTab from './UserTab';
import { Toast } from '../../services';
import { API_USER, API_URL } from '../../config/constants';
import HttpService from '../../config/http.service';

const UserManagement = () => {
  const [roleList, setRoleList] = useState([] as any);
  const [projectList, setProjectList] = useState([] as any);
  const [isLoad, setIsLoad] = useState(true)
  const getRoles = () => {
    HttpService.getRequest(API_USER.GET_ROLES).then(
      (res: any) => {
        const list = res.map((item: any) => ({ ...item, label: item.name, isSelected: false, privilegeString: item.privileges?.map((i: any) => i.name).join(', ') }));
        setRoleList(list);
      },
      (err: any) => {
        Toast(err.message, "error")
      },
    )
  }

  const getProjects = () => {
    HttpService.getRequest(API_URL.GET_PROJECT_LIST).then(
      (res: any) => {
        const list = res.map((item: any) => ({ ...item, label: item.name, isSelected: false }));
        setProjectList(list);
      },
      (err: any) => {
        Toast(err.message, "error")
      },
    )
  }

  useEffect(() => {
    if (isLoad) {
      getRoles();
      setIsLoad(false);
    }
  }, [isLoad]);

  useEffect(() => {
    getProjects();
  }, []);

  return (
    <div>
      <div className='pt-10 pl-20 pr-20 pb-0'>
            <h4>User Management</h4>
        </div>
        <div className='pl-5 pr-5 pb-20'>
          <Tabs mode="default">
            <TabHeader slot="tabHeader">User</TabHeader>
            <TabHeader slot="tabHeader">Role</TabHeader>
            <TabPanel slot="tabPanel">
              <UserTab data={{ roleList, projectList }} />
            </TabPanel>
            <TabPanel slot="tabPanel">
              <RoleManagement data={{ roleList, setIsLoad }} />
            </TabPanel>
          </Tabs>
        </div>
    </div>
  );
};

export default UserManagement;
